module.exports = __webpack_public_path__ + "static/media/play-content.e1c95a71.svg";